import { VIDEO_CALL } from '../components/voice-call/constants/video-call-constants';
import { VOICE_CALL } from '../components/voice-call/constants/voice-call-constants';

/**
 * Maps backend relationship type values to user-friendly display names
 * @param {string} backendValue - The backend relationship type value (e.g., 'PROBATION_PAROLE_OFFICER')
 * @returns {string} - The user-friendly display name (e.g., 'Probation / Parole Officer')
 */
export const mapRelationshipType = (backendValue) => {
  if (!backendValue) {
    return 'Unknown';
  }

  // Get the relationship types from voice call constants
  const relationshipTypes = VIDEO_CALL.getRelationshipTypes();
  
  // Find the matching relationship type by backend value
  const matchedType = relationshipTypes.find(
    type => type.backendValue === backendValue.toUpperCase()
  );

  // Return the display value if found, otherwise return the original value formatted
  if (matchedType) {
    return matchedType.value;
  }

  // Fallback: format the backend value to be more readable
  return formatBackendValue(backendValue);
};

/**
 * Formats a backend value to be more readable as a fallback
 * @param {string} backendValue - The backend value to format
 * @returns {string} - Formatted readable string
 */
const formatBackendValue = (backendValue) => {
  if (!backendValue) return 'Unknown';
  
  return backendValue
    .toLowerCase()
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

/**
 * Gets all available relationship types for dropdowns/selects
 * @returns {Array} - Array of relationship type objects with value, id, and backendValue
 */
export const getRelationshipTypes = () => {
  return VOICE_CALL.getRelationshipTypes();
};

/**
 * Gets privileged relationship types
 * @returns {Array} - Array of privileged relationship type strings
 */
export const getPrivilegedRelationshipTypes = 


() => {
  return VOICE_CALL.getPrivilegeRelationShipTypes();
};

/**
 * Checks if a relationship type is privileged
 * @param {string} relationshipType - The relationship type to check
 * @returns {boolean} - True if the relationship type is privileged
 */
export const isPrivilegedRelationshipType = (relationshipType) => {
  const privilegedTypes = getPrivilegedRelationshipTypes();
  return privilegedTypes.includes(relationshipType);
};

/**
 * Maps relationship type for video calls (can be extended in the future)
 * Currently uses the same mapping as voice calls
 * @param {string} backendValue - The backend relationship type value
 * @returns {string} - The user-friendly display name
 */
export const mapVideoCallRelationshipType = (backendValue) => {
  // For now, video calls use the same relationship type mapping as voice calls
  // This can be extended in the future if video calls have different relationship types
  return mapRelationshipType(backendValue);
};
